import React from 'react';
import { useParams } from 'react-router-dom';

import { Text, Box, Title, Button, createStyles, Group, Anchor, Divider } from '@mantine/core';

const SubmitTicket = () => {
  return (
    <Box>
      <Title order={1}>Submit Ticket</Title>
      <Divider my="lg" />
      <Text>
        If you are currently on the Lakeridge network, you can submit a ticket using the Service Desk Hub website at:{' '}
        <Anchor color="blue" href="https://servicedesk.ourepic.ca/">
          https://servicedesk.ourepic.ca/
        </Anchor>
      </Text>
      <Text my="md">
        Otherwise, please contact the IT Service Desk at:{' '}
        <Anchor color="blue" href="tel:905-576-8711p34357">
          905-576-8711 (34357)
        </Anchor>
      </Text>
    </Box>
  );
};

export default SubmitTicket;
